import styled, { css } from 'styled-components';
const blur = css`
  transition: filter 0.2s linear;
  filter: ${({
  imageIsLoaded
}) => imageIsLoaded ? 'blur(0px)' : 'blur(10px)'};
`;
export const WrapperNoBlurOverflow = styled.div`
  overflow: hidden;
  height: 100%;
  width: 100%;
`;
export const Wrapper = styled.div`
  height: 100%;
  transition: height 0.2s linear;

  img {
    transition: filter 0.2s linear;
    ${({
  withBlur
}) => withBlur && blur};
  }
`;
export const StyledImage = styled.img`
  width: 100%;
`;